import { AppContext } from 'in-meeting-experience-ui-components/contexts/app/context';
import { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { fetchCallObject, getCallObjectById } from '../slices/callObject/actions';
import { callObjectIdSelector } from '../slices/callObject/selectors';
import { meetingIdSelector, meetingStartTimeSelector, meetingUUIDSelector } from '../slices/google/selectors';
const useCallObject = () => {
  const dispatch = useDispatch();
  const {
    selectors: {
      isNotInLiveMeeting,
      isInLiveMeeting
    }
  } = useContext(AppContext);
  const meetingId = useSelector(meetingIdSelector);
  const meetingUUID = useSelector(meetingUUIDSelector);
  const meetingStartTime = useSelector(meetingStartTimeSelector);
  const storeCallObjectId = useSelector(callObjectIdSelector);
  const {
    callObjectId
  } = useParams();

  // fetch call object (live meeting)
  useEffect(() => {
    if (meetingId && meetingUUID && meetingStartTime && isInLiveMeeting) {
      dispatch(fetchCallObject());
    }
  }, [dispatch, meetingId, isInLiveMeeting, meetingUUID, meetingStartTime]);

  // fetch call object (past or draft meeting)
  useEffect(() => {
    if (isNotInLiveMeeting && !storeCallObjectId && callObjectId) {
      dispatch(getCallObjectById(callObjectId));
    }
  }, [dispatch, callObjectId, isNotInLiveMeeting, storeCallObjectId]);
};
export default useCallObject;